<template>
    <div class='Box'>
        <!-- <Echarts/> -->
        <el-row class="Center">
            <el-col class="borde">
                <div >
                    <el-col class="bordeLeft">催促签收</el-col>
                </div>
            </el-col>
        </el-row>
        <!-- table -->
        <div class="table">
          <el-row >
            <el-col :span="24" v-if="showCon">
                <el-col :span='24' class="Bot" v-loading="false">
                  
                        <el-table
                        ref="multipleTable"
                        :data="tableData"
                        tooltip-effect="dark"
                        style="width: 100%"
                        :header-cell-style="tableHeaderColor"
                        @row-click="handle"
                        >
                        
                          <el-table-column
                            label="序号"
                            min-width="5%"
                            type="index"
                            >
                        </el-table-column>

                        <el-table-column
                            prop="merchCode"
                            min-width="10%"
                            label="渠道号"
                        >
                        </el-table-column>
                        <el-table-column
                            prop="orderId"
                            label="订单号"
                            min-width="20%"
                            show-overflow-tooltip>
                        </el-table-column>
                        <el-table-column
                            prop="status"
                            label="订单状态"
                            min-width="10%"
                            >
                        </el-table-column>
                        <el-table-column
                            prop="billNum"
                            label="票据号码"
                            min-width="10%"
                            >
                        </el-table-column>

                        <el-table-column
                            prop="cmpName"
                            label="转让人"
                            min-width="10%"
                            >
                        </el-table-column>
                        <el-table-column
                            prop="channelAcctName"
                            label="受让人"
                            min-width="10%"
                            >
                        </el-table-column>
                        <el-table-column
                            prop="overHourBuy"
                            label="签收时长"
                            min-width="10%"
                            >
                        </el-table-column>
                        <el-table-column
                            prop="qsOverTime"
                            label="超期时间"
                            min-width="8%"
                            >
                        </el-table-column>
                        <el-table-column
                            prop="boverCs"
                            label="提醒次数"
                            min-width="8%"
                            >
                        </el-table-column>
                        <el-table-column
                            prop="zip"
                            label="操作"
                            min-width="15%"
                            >
                            <template slot-scope="scope">
                                <el-button
                                @click.stop="solvedClick(scope.row.orderId)"
                                type="primary"
                                size="small"
                                >
                                已处理
                                </el-button>
                            </template>
                        </el-table-column> 
                    </el-table>
                </el-col> 
            </el-col>
        </el-row>
        </div>
        <!-- pagination -->
        <div class="pagination">
          <el-pagination
            background
            @current-change="handleCurrentChange"
            :current-page.sync="currentPage"
            layout="prev, pager, next"
            prev-text="上一页"
            next-text="下一页"
            :page-size="pagesize"
            :total=this.totalPage>
          </el-pagination>
        </div>

        <el-dialog
          :visible.sync="solvedDialogVisible"
          width="30%"
          >
          <span>订单已处理，可继续流转进行交易</span>
          <span slot="footer" class="dialog-footer">
            <el-button type="primary" @click="solvedDialogVisibleClick">确 定</el-button>
          </span>
        </el-dialog>
        
    </div>
</template>

<script>

export default {
    components:{

    },
    data(){
        return{
            testData: [{
            orderNumber:'1',
            name: '4223',
            bill:'O2020022842231430123',
            six:'待背书',
            receive:'2220000000000000001111111111111',
            thousand:'杭州某某有限公司可换行',
            now:'北京某某有限公司可换行',
            button1:'2.5小时',
            button2:'00:03:34',
            times:'1',
            visible: false,
            }],
            showCon:true,
            tableData: [],
            solvedDialogVisible:false,
            solvedId:'',
            zhuanagtai:'',
            totalPage:0,
            currentPage:1,
            pagesize:10,
        }
    },
    computed: {

    },
    watch: {

    },
    mounted(){
        this.handleAjax(this.currentPage)
        // if(this.tableData.status == undefined) {
        //   this.zhuanagtai = '未签收'
        //   alert('可以')
        // }
        // console.log(this.tableData.status, '5566')
        if(this.$route.query.code&&this.$route.query.code==1){
            this.dialogVisible=!this.dialogVisible
        }
    },
    methods:{
      handleCurrentChange(val) {
            this.handleAjax(val);
      },
      // 点击已处理按钮
      solvedClick(val){
        this.solvedDialogVisible = true
        this.solvedId = val
      },
      // 点击已处理确定按钮
      solvedDialogVisibleClick(){
        this.solvedDialogVisible = false
        let testId = this.solvedId
        this.solvedBtn(testId)
      },
      // 点击已处理按钮，发送数据请求
      solvedBtn(value){
      this.ajax.post('/jyOder/hadDealQsOverTime',{bizContent:{orderId:value}})
      .then(
        result=>{
          if(result.data.status=='0000'){
            this.currentPage=1;
            this.handleAjax(this.currentPage)
            // alert(value)
            // this.isremindok=false
            // this.statecapture()
            // swal({
            //   text: '已成功通过',
            //   icon:'success',
            //   timer: 3000,
            //   buttons: false
            // })
          }
          else{
            // swal({
            //   text: result.data.message,
            //   timer: 3000,
            //   buttons: false
            // })
          }
        }
      )
    },
      handleAjax(val){
            this.loading=true
            this.ajax.post('/jyOder/jyOrderList',{bizContent:{currentPage:val,pageSize:this.pagesize,statusType:'催促签收',merchCode:''}})
                .then(
                    result=>{
                        if(result.data.status=='0000'){ 
                            let add = result.data.data.data
                            add.map((item,index)=>{
                                add[index].xh=index+1
                            })
                            this.tableData=add
                            this.tableData.forEach((item) => {
                              if(item.status == 100) {
                                item.status = '待审核'
                              }else if(item.status == 600) {
                                item.status = '待背书'
                              }else if(item.status == 610 || 620 || 630) {
                                item.status = '待签收'
                              }
                            })
                            this.totalPage = result.data.data.pages
                            if(this.radio2=='0'){
                                if(this.tableData.length==0){
                                    this.showCon=false
                                    //下面是修改后的代码，为了让表格显示出来
                                    // this.showCon=true
                                }else{
                                    this.showCon=true
                                }
                            }
                            this.loading=false
                        }else{
                            }
                        }
                )
                
        },
        handle(row, event, column){
          this.$router.push({
                  name:'OrderDetail',
                  query:{
                      oId:row.orderId,
                      wendang: '催促签收订单-详情',
                  }
              })
        },

       tableHeaderColor({ row, column, rowIndex, columnIndex }) {
          if (rowIndex === 0) {
            return 'background-color: rgba(244,244,244,1);color: rgba(51,51,51,1);font-weight: bold;font-size:14px; height:55px;'
          }
        },

      handleClose(done) {
        this.$confirm('确认关闭？')
          .then(_ => {
            done();
          })
          .catch(_ => {});
        },

        handleRowClick(val){
            this.$router.push({
                name:'orderInfor',
                query:{
                    oid:val.orderId
                }
            })
        },
    }
}
</script>

<style  scoped>
.Box{
    background: white;
    height: 883px;
}

.table{
  background:rgba(255,255,255,1);
  padding-left: 31px;
  padding-right: 38px;
  
}

.Bot{
     height: auto;
     height: 682px;
     background: white;
     box-shadow:0px 3px 15px 0px rgba(0,0,0,0.06);
     border-radius:8px;
}

.pagination{
  height: 111px;
  text-align: center;
  padding-top: 50px;
  box-sizing: border-box;
}

.Bot>>>.cell{
    font-size: 14px;
    text-align: center;
    font-weight: 400;
    color:rgba(51,51,51,1);
    font-family:PingFangSC-Regular,PingFang SC;
}


.button{
    padding: 12px 5px;
    border-radius: unset;
    height: 34px;
    color: #1884FC; 
    background: white;
}


.line{
  width: 920px;
  height: 1px;
  box-sizing: border-box;
  background: #E3E4E5;
  margin-left: 14px;
  margin-right: 13px;
  margin-bottom: 21px;
}

.borde{
    height: 90px;
    padding-left: 34px;
    padding-top: 38px;
}
.bordeLeft{
    height:33px;
    font-size:24px;
    font-family:PingFangSC-Regular,PingFang SC;
    font-weight:400;
    color:rgba(0,0,0,1);
    line-height:33px;
}
.bordeRight{
    text-align: right;
    padding-right: 20px;
}

.closeBtn{
  width:56px;
  border-radius:4px;
  color: #2B89EB;
  text-align: center;
  border:1px solid #2B89EB;
}

.closedHeader{
  border: none;
}

</style>


// WEBPACK FOOTER //
// src/page/orderexception/urgedsign.vue